import { ReactNode } from 'react';
import { default as BaseCard } from '@fd/frontend/components/ui/Card';
import Flex from '@fd/frontend/components/ui/Flex';

function Card({ children }: { children: [ReactNode, ReactNode] }) {
  return (
    <BaseCard>
      <div className="flex gap-5 justify-between items-center flex-col sm:flex-row">
        <div className="w-full sm:w-[400px] sm:pr-5 sm:border-r sm:border-border">
          {children[0]}
        </div>
        <div className="w-full sm:w-auto sm:grow">{children[1]}</div>
      </div>
    </BaseCard>
  );
}

function Body({ children }: { children: ReactNode }) {
  return <Flex.Col gap="2">{children}</Flex.Col>;
}

function Title({ children }: { children: ReactNode }) {
  return <span className="font-semibold">{children}</span>;
}

function Description({ children }: { children: ReactNode }) {
  return <span className="text-sm text-secondary">{children}</span>;
}

const OptionField = {
  Card,
  Body,
  Title,
  Description,
};

export default OptionField;
